exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#prwCard .v--modal-box.v--modal{min-height:500px!important;min-width:680px!important}#prwCard #attr__wrapper .layout:not(#geometry-panel){margin-top:20px}#prwCard .v-tabs__div:not(:last-child){padding-right:10px;background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#prwCard .v-select__selection{font-size:12px!important}#prwCard .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#prwCard .btn--card{position:absolute;right:10px;bottom:10px}#prwCard .caption--identification{display:inline;text-align:center;vertical-align:super}.prw-card__watermeters{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66b40114","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/watermeters/modals/PrwCard.vue
// module id = 1734
// module chunks = 0